import { render } from "./LabelCropsPanel.vue?vue&type=template&id=d8283d4c&scoped=true"
import script from "./LabelCropsPanel.vue?vue&type=script&lang=js"
export * from "./LabelCropsPanel.vue?vue&type=script&lang=js"

import "./LabelCropsPanel.vue?vue&type=style&index=0&id=d8283d4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8283d4c"]])

export default __exports__